import type { Sparte } from '@/features/Global/types';

/**
 * „krad-artige" KFZ-Sparte = Kraftrad-Sparte: `krad` (V1) und `kradv2` (Fake-Sparte für die
 * V2-Berechnung). Zentralisiert die zahlreichen `sparte === 'krad'`-Sonderpfade im geteilten
 * KFZ-Code (WKZ-abhängiges Mindestalter, Rabattschutz-/SF-Klassen-Sichtbarkeit), damit kradv2
 * überall wie krad behandelt wird und eine weitere Krad-Variante nur hier ergänzt werden muss.
 * Analog {@see isPkwSparte}.
 */
export const isKradSparte = (sparte: Sparte | null | undefined): boolean =>
  sparte === 'krad' || sparte === 'kradv2';
